// cf7 post form to hubspot form
jQuery(function ($) {
  const getFieldValue = (inputs, field) => {
    const foundField = inputs.find((input) => input.name === field);
    return foundField?.value;
  };
  const STAFF_CONTACT_FORM_ID = '3816';
  document.addEventListener(
    'wpcf7submit',
    function (event) {
      // only fire on the staff contact form
      if (event.detail.contactFormId == STAFF_CONTACT_FORM_ID) {
        const inputs = event.detail.inputs;
        const baseUrl = 'https://api.hsforms.com/submissions/v3/integration/submit';
        const portalId = '3361203';
        const formGuid = 'da39bb1e-f54c-47a0-98ae-27fbac816c25';
        const postUrl = `${baseUrl}/${portalId}/${formGuid}`;
        const firstName = getFieldValue(inputs, 'first-name');
        const lastName = getFieldValue(inputs, 'last-name');
        const email = getFieldValue(inputs, 'email');
        const phoneNumber = getFieldValue(inputs, 'phone-number');
        const preferredStaff = getFieldValue(inputs, 'preferred-staff');
        const message = getFieldValue(inputs, 'message');
        const newsletterAcceptance = getFieldValue(inputs, 'newsletter-acceptance') ? 'Yes' : 'No';
        const data = {
          fields: [
            {
              name: 'firstname',
              value: firstName,
            },
            {
              name: 'lastname',
              value: lastName,
            },
            {
              name: 'phone',
              value: phoneNumber,
            },
            {
              name: 'email',
              value: email,
            },
            {
              name: 'team_salesperson',
              value: preferredStaff,
            },
            {
              name: 'message',
              value: message,
            },
            {
              name: 'subscribe_me_to_the_birchwood_credit_solutions_newsletter',
              value: newsletterAcceptance,
            },
          ],
          context: {
            pageUri: window.location.href,
            pageName: document.title,
          },
        };
        const finalData = JSON.stringify(data);
        $.ajax({
          method: 'POST',
          url: postUrl,
          data: finalData,
          contentType: 'application/json',
          success: function (response) {
            if (response.redirectUri) {
              console.log('Form posted successfully to Hubspot');
            }
          },
          error: function (error) {
            console.log('Error posting form to Hubspot');
          },
        });
      }
    },
    false
  );
  document.addEventListener(
    'wpcf7mailsent',
    function (event) {
      if (event.detail.contactFormId == STAFF_CONTACT_FORM_ID) {
        $('.staff__modal').addClass('staff__modal--form-sent');
      }
    },
    false
  );
});
